import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const EMSA = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Electrophoretic Mobility Shift Assay (EMSA): This assay was designed to see the interaction between the aptamer and the protein, in this case the C-Reactive protein (CRP), and to see if both of our aptamers (primary and secondary) compete for the same binding site of the protein. This assay consists in making a NAITVE PAGE gel electrophoresis, with both elements: the protein and the aptamer. This protocol was adapted from Hellman & Fried (2007) [2].</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/7.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 6. Diagram of EMSA protocol. Created with<br/> BioRender.com.</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EMSA;
